import React from 'react';
import cn from 'classnames';

import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';

import baseStyles from '../tenantInvestorSet.module.scss';
import { buttonStyles } from '@dealroadshow/uikit-button';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './learnMore.module.scss';

const LearnMore = () => (
  <div className={ styles.learnMoreContainer }>
    <div className={ styles.learnMoreDescription }>
      <div className={ baseStyles.sectionTitle }>Ready to learn more?</div>
      <div className={ baseStyles.sectionDescription }>
        Get started or schedule a demo with a product specialist who can answer
        any questions and show you the platform.
      </div>
    </div>

    <div className={ styles.learnMoreButtons } data-test="learnMoreButtons">
      <GetStartedButton className={ cn(buttonStyles.secondary, baseStyles.secondaryBtn) } />
      <BookDemoButton legacy className={ spacesStyles.mrn } />
    </div>
  </div>
);

export default LearnMore;
